import { render, staticRenderFns } from "./global-config.vue?vue&type=template&id=ad12c5da&scoped=true"
import script from "./global-config.vue?vue&type=script&lang=js"
export * from "./global-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad12c5da",
  null
  
)

export default component.exports